import { render, staticRenderFns } from "./StatsList.vue?vue&type=template&id=40761438"
import script from "./StatsList.vue?vue&type=script&lang=js"
export * from "./StatsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports